export default __webpack_public_path__ + "static/algorand-a607985f265becfb98cecde03155c0a2.png";